var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"pd:xl"},[_c('div',{staticClass:"preloader"})])
}]

export { render, staticRenderFns }